import { render, staticRenderFns } from "./GestionnaireDepenses.vue?vue&type=template&id=453a5538&"
import script from "./GestionnaireDepenses.js?vue&type=script&lang=js&"
export * from "./GestionnaireDepenses.js?vue&type=script&lang=js&"
import style0 from "./GestionnaireDepenses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports